import React from 'react';

import Input from 'components/Misc/Form/Input';
import Select from 'components/Misc/Form/Select';
import Textarea from 'components/Misc/Form/Textarea';
import Checkbox from 'components/Misc/Form/Checkbox';
import Duration from 'components/Misc/Form/Duration';
import Currency from 'components/Misc/Form/Currency';
import Datepicker from 'components/Misc/Form/Datepicker';
import Avatar from 'components/Misc/Form/Avatar';
import Button from 'components/Misc/Form/Button';
import Type from 'components/Misc/Form/Type';
import Thumbnail from 'components/Misc/Form/Thumbnail';
import File from 'components/Misc/Form/File';
import Files from 'components/Misc/Form/Files';

const Form = ({ onSubmit, className, children }) => {
	return (
		<form onSubmit={onSubmit} className={className}>
			{children}
		</form>
	);
};

export {
	Input,
	Select,
	Textarea,
	Checkbox,
	Duration,
	Currency,
	Datepicker,
	Avatar,
	Button,
	Type,
	Thumbnail,
	File,
	Files,
	Form,
};